import { render } from "./ChangePasswordComponent.vue?vue&type=template&id=0fb813b8"
import script from "./ChangePasswordComponent.vue?vue&type=script&lang=js"
export * from "./ChangePasswordComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/dev.soft.team/www/autoringen/autoringen.dev.soft.team/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/themes/default/js/components/ChangePasswordComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fb813b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fb813b8', __exports__)) {
    console.log('reload')
    api.reload('0fb813b8', __exports__)
  }
  
  module.hot.accept("./ChangePasswordComponent.vue?vue&type=template&id=0fb813b8", () => {
    console.log('re-render')
    api.rerender('0fb813b8', render)
  })

}


export default __exports__